var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 44,
    viewBox: "0 0 58 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "folders",
    d: "M50.9996 33C53.5532 33 55.7139 30.9375 55.7139 28.2857V12.5714C55.7139 10.0179 53.5532 7.85714 50.9996 7.85714H39.4103C37.3478 7.85714 35.2853 7.07143 33.8121 5.59821L31.2585 3.04464C30.3746 2.16071 29.196 1.57143 27.9192 1.57143H16.4282C13.7764 1.57143 11.7139 3.73214 11.7139 6.28571V28.2857C11.7139 30.9375 13.7764 33 16.4282 33H50.9996ZM16.4282 34.5714C12.8924 34.5714 10.1424 31.8214 10.1424 28.2857V6.28571C10.1424 2.84821 12.8924 0 16.4282 0H27.9192C29.5889 0 31.1603 0.6875 32.3389 1.86607L34.9907 4.51786C36.1692 5.69643 37.7407 6.28571 39.4103 6.28571H50.9996C54.4371 6.28571 57.2853 9.13393 57.2853 12.5714V28.2857C57.2853 31.8214 54.4371 34.5714 50.9996 34.5714H16.4282ZM0.713867 15.7143C0.713867 12.2768 3.46387 9.42857 6.99958 9.42857V11C4.3478 11 2.2853 13.1607 2.2853 15.7143V37.7143C2.2853 40.3661 4.3478 42.4286 6.99958 42.4286H41.571C44.1246 42.4286 46.2853 40.3661 46.2853 37.7143H47.8567C47.8567 41.25 45.0085 44 41.571 44H6.99958C3.46387 44 0.713867 41.25 0.713867 37.7143V15.7143Z",
    fill: "#DBFF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolders);
export default __webpack_public_path__ + "static/media/folders.fb219bd680b36422e4140d149884b5af.svg";
export { ForwardRef as ReactComponent };